const hardwareConstants = {
    exitTimeoutOnSecondDisplayDetected: 10, // seconds
};

export default hardwareConstants;
